import React, { useState, useEffect } from "react";

import HeaderTemplate from "../templates/HeaderTemplate";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button } from "@mui/material";

import {
  MissionConditions,
  Mission,
  ParsedMission,
  MissionDisplayDetail,
} from "../common/type/type";

import { MissionDetailShow } from "../organisms/MissionDetailShow";
import ActionDialogButton from "../atoms/ActionDialogButton";
import { getMissionDetail, deleteMission } from "../../services/missionApi";

function parseMockMission(raw: Mission): ParsedMission {
  return {
    id: raw.id, // 必要に応じて補完
    title: raw.title,
    conditions: JSON.parse(raw.conditions) as MissionConditions,
    point: raw.point,
    startedAt: raw.startedAt,
    endedAt: raw.endedAt,
    deletedAt: "", // 必要に応じて補完
    createdAt: "", // 必要に応じて補完
    updatedAt: "", // 必要に応じて補完
    missionType: {
      id: raw.missionType.id,
      name: raw.missionType.name, // 補完
      text: raw.missionType.text, // 補完
    },
    missionDisplay: {
      missionDisplayTypeId: raw.missionDisplay.missionDisplayType.id,
      detail: JSON.parse(raw.missionDisplay.detail) as MissionDisplayDetail,
    },
  };
}

export default function MissionDetail() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const [data, setData] = useState<Mission>();
  const [error, setError] = useState(null);

  /**
   * URLのパスパラメータにあるadvertisement_idを格納する変数
   */
  const paramsMissionId: string = String(useParams().mission_id);

  console.log(paramsMissionId);

  useEffect(() => {
    const fetchMission = async () => {
      const result = await getMissionDetail(paramsMissionId);
      if (result) {
        setData(result);
      } else {
        setError(
          "データ取得に失敗しました。ログインし直すか、設計にご連絡ください。"
        );
      }
    };
    fetchMission();
  }, [paramsMissionId]);

  if (error) return <p>{error}</p>;
  if (!data) return <p>読み込み中...</p>;

  const parsedMission = parseMockMission(data);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      await deleteMission(paramsMissionId);
      navigate(`/missions`);
    } catch (err) {
      alert(
        "ミッションの削除に失敗しました。ログインし直すか、設計にご連絡ください。"
      );
    }
  };

  const handleChangeEditMode = () => {
    navigate(`/missions/${paramsMissionId}/edit`);
  };

  return (
    <div>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <div>
          <HeaderTemplate />
        </div>

        <Box
          sx={{
            paddingTop: "20px",
          }}
        >
          <MissionDetailShow row={parsedMission}></MissionDetailShow>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
          <ActionDialogButton
            type="detail"
            open={open}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            handleAction={handleDelete}
            handleChangeEditMode={handleChangeEditMode}
            changeEditMode={true}
          />
        </Box>
      </Box>
    </div>
  );
}
